import { atomWithReset } from 'jotai/utils';

import { NetSuiteJournalEntryLineExpanded } from '../data/types/NetSuiteJournalEntryLineExpanded';
import { NetSuiteJournalEntryFields } from './NetSuiteJournalEntryRequestForm.types';

export const netSuiteJournalEntryFieldValuesState = atomWithReset<Partial<NetSuiteJournalEntryFields>>({});

export const netSuiteJournalEntryItemListState = atomWithReset<NetSuiteJournalEntryLineExpanded[]>([]);
